export const urlToFunction = {
  'Video/Cut': {
    url: 'https://online.hitpaw.com/toolbox/cut-video-online/upload?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=EJhT-FZWm8FStLVa&track[type]=2&track[sid]=118&track[source]=seo&page=https://online.hitpaw.com/&source=seo',
    name: 'Video Cut',
    label: '09VC',
  },

  'Video/Cutter': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video Cutter',
    label: '11VC',
  },

  'Video/Resize': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video Resize',
    label: '20VR',
  },

  'Video/RemoveWatermark': {
    url: 'https://online.hitpaw.com/toolbox/video/remove-watermark-online?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=EJhT-FZWm8FStLVa&track[type]=2&track[sid]=118&track[source]=seo&page=https://online.hitpaw.com/&source=seo',
    name: 'Video RemoveWatermark',
    label: '01VWR',
  },

  'Video/RemoveWatermarkV2': {
    url: 'https://online.hitpaw.com/toolbox/video/remove-watermark-online?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=EJhT-FZWm8FStLVa&track[type]=2&track[sid]=118&track[source]=seo&page=https://online.hitpaw.com/&source=seo',
    name: 'Video RemoveWatermark',
    label: '01VWR',
  },

  'Video/RemoveWatermarkV3': {
    url: 'https://online.hitpaw.com/toolbox/video/remove-watermark-online?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=EJhT-FZWm8FStLVa&track[type]=2&track[sid]=118&track[source]=seo&page=https://online.hitpaw.com/&source=seo',
    name: 'Video RemoveWatermark',
    label: '01VWR',
  },

  'Video/Compress': {
    url: 'https://online.hitpaw.com/online-video-compressor.html',
    name: 'Video Compress',
    label: '24VC',
  },

  'Video/Merge': {
    url: 'https://online.hitpaw.com/tools/',
    name: '',
    label: '13VM',
  },

  'Video/AddMusic': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video Merge',
    label: '21VAM',
  },

  'Video/ToGif': {
    url: 'https://online.hitpaw.com/video-to-gif-online.html',
    name: '',
    label: '37ToGif',
  },

  'Video/ChangeSpeed': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video ToGif',
    label: '12VCS',
  },

  'Video/CropAndRotate': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video CropAndRotate',
    label: '18VCR',
  },

  'Video/Convert': {
    url: 'https://online.hitpaw.com/online-video-converter.html',
    name: 'Video Convert',
    label: '36VC',
  },

  'Video/AddWatermark': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video AddWatermark',
    label: '15VAW',
  },

  'Video/AddSubtitle': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video AddSubtitle',
    label: '19VAS',
  },

  'Video/DynamicPhoto': {
    url: 'https://online.hitpaw.com/animate-old-photos-online.html',
    name: 'Video DynamicPhoto',
    label: '22AO',
  },

  'Video/FaceAnimator': {
    url: 'https://online.hitpaw.com/online-face-animator.html',
    name: 'Video FaceAnimator',
    label: '23FA',
  },

  'Video/Mute': {
    url: 'https://online.hitpaw.com/online-mute-video.html',
    name: 'Video Mute',
    label: '25VM',
  },

  'Video/Reverse': {
    url: 'https://online.hitpaw.com/tools/',
    name: 'Video Reverse',
    label: '16VR',
  },

  'Video/Loop': {
    url: 'https://online.hitpaw.com/tools/',
    name: '',
    label: '17VL',
  },

  'Audio/Convert': {
    url: 'https://online.hitpaw.com/online-audio-converter.html',
    name: 'Video Loop',
    label: '29AC',
  },

  'Audio/Extract': {
    url: 'https://online.hitpaw.com/online-audio-extractor.html',
    name: 'Audio Extract',
    label: '26AE',
  },

  'Audio/Compress': {
    url: 'https://online.hitpaw.com/online-audio-compressor.html',
    name: 'Audio Compress',
    label: '28AC',
  },

  'Audio/ChangeVolume': {
    url: 'https://online.hitpaw.com/online-volume-changer.html',
    name: 'Audio ChangeVolume',
    label: '30ACV',
  },

  'Audio/ChangeSpeed': {
    url: 'https://online.hitpaw.com/online-audio-speed-changer.html',
    name: 'Audio ChangeSpeed',
    label: '31ACS',
  },

  'Audio/Cut': {
    url: 'https://online.hitpaw.com/online-audio-cutter.html',
    name: 'Audio Cut',
    label: '32AC',
  },

  'Audio/Merge': {
    url: 'https://online.hitpaw.com/online-audio-joiner.html',
    name: 'Audio Merge',
    label: '27AM',
  },

  'Audio/Mix': {
    url: 'https://online.hitpaw.com/add-music-to-audio-online.html',
    name: 'Audio Mix',
    label: '33AM',
  },

  'Image/Convert': {
    url: 'https://online.hitpaw.com/online-image-converter.html',
    name: 'Image Convert',
    label: '34IC',
  },

  'Image/BackgroundRemove': {
    url: 'https://online.hitpaw.com/online-background-remover.html',
    name: 'Image BackgroundRemove',
    label: '08BR',
  },

  'Tiktok/RemoveWatermark': {
    url: 'https://online.hitpaw.com/toolbox/video/remove-tt-watermark-online?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=Qii1Y8nID9Dj5wWZ&track[source]=seo&source=seo',
    name: 'Tiktok RemoveWatermark',
    label: '03TWR',
  },

  'Image/WatermarkRemove': {
    url: 'https://online.hitpaw.com/toolbox/image/remove-watermark?track[utm_source]=seo&track[utm_medium]=seo&track[realMedium]=seo&track[cross_end_id]=EJhT-FZWm8FStLVa&track[type]=2&track[sid]=118&track[source]=seo&page=https://online.hitpaw.com/&source=seo',
    name: 'Image WatermarkRemove',
    label: '02IWR',
  },

  'Image/Enhancer': {
    url: 'https://online.hitpaw.com/online-photo-enhancer.html',
    name: 'Image Enhancer',
    label: '05PE',
  },

  'Video/ScreenRecording': {
    url: 'https://online.hitpaw.com/online-screen-recorder.html',
    name: 'Video ScreenRecording',
    label: '06SR',
  },

  'Video/Enhancer': {
    url: 'https://online.hitpaw.com/online-video-enhancer.html',
    name: 'Video Enhancer',
    label: '04VE',
  },

  'Video/EnhancerPreview': {
    url: 'https://online.hitpaw.com/online-video-enhancer.html',
    name: 'Video Enhancer',
    label: '04VE',
  },
};
